import {BaseApiRequestParams} from "../../infrastructure/models/params/base-api-request-params";

export class FullAthletesRequestParams extends BaseApiRequestParams {
  athletesIds: Array<Number>

  constructor(athletesIds: Array<Number>, competitionId: Number, filter: String = '', topBookmaker: Boolean = null, fullDetails: Boolean = true) {
    super(`athletes/${filter}`);

    this.athletesIds = athletesIds;
    this.competitionId = competitionId;
    this.fullDetails = fullDetails;
    this.topBookmaker = topBookmaker;
  }

  get athletesParam() {
    return this.athletesIds?.length > 0  ? `&athletes=${this.athletesIds.toString()}` : '';
  }

  get competitionIdParam() {
    return this.competitionId > 0 ? `&competitionId=${this.competitionId}` : ``;
  }

  get fullDetailsParam() {
    return this.fullDetails ? `&fullDetails=${this.fullDetails}` : ``;
  }

  get topBookmakerParam() {
    return this.topBookmaker ? `&topBookmaker=${this.topBookmaker}` : ``;
  }

  get lastUpdateIdParam() {
    return (this.lastUpdateId ? `&lastUpdateId=${this.lastUpdateId}` : '');
  }

  toString(): String {
    return super.toString() + this.athletesParam + this.competitionIdParam + this.fullDetailsParam + this.topBookmakerParam + this.lastUpdateIdParam;
  }

  equals(model: FullAthletesRequestParams): * {
    let equals = super.equals(model);

    equals &= this.athletesParam === model.athletesParam;
    equals &= this.competitionIdParam === model.competitionIdParam;
    equals &= this.fullDetailsParam === model.fullDetailsParam;

    return equals;
  }
}
